import {
  CatalogBodyVariableItemResponse,
  CatalogColorVariableItemResponse,
  CatalogItemResponse,
  CatalogNormalItemResponse
} from '../../api/response/catalog';

export type CatalogNormalItem = { type: 'normal' } & CatalogNormalItemResponse;
export type CatalogBodyVariableItem = {
  type: 'body-variable';
} & CatalogBodyVariableItemResponse;
export type CatalogColorVariableItem = {
  type: 'color-variable';
} & CatalogColorVariableItemResponse;

export type CatalogItem = CatalogNormalItem | CatalogBodyVariableItem | CatalogColorVariableItem;

const appEnv = process.env.REACT_APP_ENV;

export function catalogIconUrl(icon: string) {
  if (appEnv) {
    return `https://web.sd.${appEnv}.acbaa.srv.nintendo.net/resources/catalog/icon/${icon}`;
  } else {
    return '';
  }
}

export function catalogDetailIconUrl(item: CatalogItem, index?: number, uniqueId?: number): string {
  let icon: string;
  switch (item.type) {
    case 'normal':
      icon = item.icon;
      break;
    case 'body-variable':
      const rebodyPattern =
        item.rebody_pattern && item.rebody_pattern.find(pattern => pattern.index === index);
      if (rebodyPattern) {
        icon = rebodyPattern.icon;
      } else {
        icon = 'rebody-empty';
      }
      break;
    case 'color-variable':
      const variation = item.variations.find(pattern => pattern.unique_id === uniqueId);
      if (variation) {
        icon = variation.icon;
      } else {
        icon = 'variations-empty';
      }
      break;
    default:
      return '';
  }
  return catalogIconUrl(icon);
}

export function convertToCatalogItem(response: CatalogItemResponse): CatalogItem {
  if (response.hasOwnProperty('rebody_pattern')) {
    return { type: 'body-variable', ...(response as CatalogBodyVariableItemResponse) };
  }
  if (response.hasOwnProperty('variations')) {
    return { type: 'color-variable', ...(response as CatalogColorVariableItemResponse) };
  }
  return { type: 'normal', ...(response as CatalogNormalItemResponse) };
}
